// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"42d69a9d","193":"ddd34baa","447":"cb9877cb","537":"b58cf40a","775":"db51e482","787":"441f6461"}[chunkId] + ".chunk.js";
};